import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';

export const DEVICES_PATH = '/devices/:tab';

export const routes = [
    {
        component: lazy(() => import('module/devices/DevicesPage')),
        permissions: [
            'Device_Read',
            'Device_Create',
            'Device_Edit',
            'Device_Delete',
            'DeviceLog_Read',
            'DeviceLog_Create',
        ],
        path: DEVICES_PATH,
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
    },
];
